import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Skeleton } from '@/components/ui/skeleton.component';

const DEFAULT_VISIBLE_DAYS_PLACEHOLDER = 3;
const DEFAULT_SLOTS_PER_DAY_PLACEHOLDER = 4;
const ARRIVAL_ORDER_SLOTS_PER_DAY_PLACEHOLDER = 2;

const ARROW_PLACEHOLDER = 'flex items-center justify-center px-1 py-3';

interface RescheduleSlotsSkeletonProps {
  visibleDays?: number;
  isArrivalOrder?: boolean;
}

export function RescheduleSlotsSkeleton({
  visibleDays = DEFAULT_VISIBLE_DAYS_PLACEHOLDER,
  isArrivalOrder = false,
}: RescheduleSlotsSkeletonProps) {
  const slotsPerDay = isArrivalOrder ? ARRIVAL_ORDER_SLOTS_PER_DAY_PLACEHOLDER : DEFAULT_SLOTS_PER_DAY_PLACEHOLDER;

  return (
    <div
      data-testid={DataTestIdEnum.APPOINTMENT_RESCHEDULE_SKELETON}
      className="flex w-full items-start justify-center gap-4"
    >
      <div className={ARROW_PLACEHOLDER} aria-hidden>
        <Skeleton className="size-6 rounded-full" />
      </div>

      <div className="flex flex-1 items-start gap-4">
        {Array.from({ length: visibleDays }).map((_, dayIndex) => (
          <div key={dayIndex} className="flex flex-1 flex-col items-center gap-2">
            <div className="flex flex-col items-center gap-1">
              <Skeleton className="h-5 w-12" />
              <Skeleton className="h-6 w-10" />
            </div>
            {Array.from({ length: slotsPerDay }).map((__, slotIndex) => (
              <Skeleton key={slotIndex} className="h-10 w-full rounded-lg" />
            ))}
          </div>
        ))}
      </div>

      <div className={ARROW_PLACEHOLDER} aria-hidden>
        <Skeleton className="size-6 rounded-full" />
      </div>
    </div>
  );
}
